// v10/src/services/wbService.js
// Cliente para los endpoints de W&B Peso y Balance.

import api from './apiService';

export const wbService = {
  // ── Parte 1 ─────────────────────────────────────────────────────

  // GET /api/aircraft/:aircraftId/wb-data
  async getAircraftWbData(aircraftId) {
    const res = await api.get(`/api/aircraft/${aircraftId}/wb-data`);
    return res.data;
  },

  // POST /api/wb/calculate (no persiste — legacy, parte 1)
  async calculate(aircraftId, inputs) {
    const res = await api.post('/api/wb/calculate', {
      aircraft_id: aircraftId,
      inputs,
    });
    return res.data;
  },

  // ── Parte 2 ─────────────────────────────────────────────────────

  // POST /api/wb/save
  // El backend RECALCULA con services/wbService.js y persiste snapshot completo.
  async save({ aircraft_id, flight_auth_id, inputs, notes }) {
    const res = await api.post('/api/wb/save', {
      aircraft_id,
      flight_auth_id: flight_auth_id || null,
      inputs,
      notes: notes || null,
    });
    return res.data;
  },

  // GET /api/wb/history
  async history({ aircraft_id, pilot_id, limit } = {}) {
    const params = new URLSearchParams();
    if (aircraft_id) params.set('aircraft_id', aircraft_id);
    if (pilot_id) params.set('pilot_id', pilot_id);
    if (limit) params.set('limit', String(limit));
    const qs = params.toString();
    const res = await api.get(`/api/wb/history${qs ? '?' + qs : ''}`);
    return res.data;
  },

  // GET /api/wb/:id (snapshot completo)
  async getById(id) {
    const res = await api.get(`/api/wb/${id}`);
    return res.data;
  },

  // GET /api/wb/flight-auths-for-aircraft?aircraft_id=X
  // Devuelve flight_authorizations del piloto (current user) para esa aeronave,
  // status='authorized', sin límite de fecha, LIMIT 20.
  async listFlightAuthsForAircraft(aircraftId) {
    const res = await api.get('/api/wb/flight-auths-for-aircraft', {
      params: { aircraft_id: aircraftId },
    });
    return res.data;
  },
};

export default wbService;
